import { Box, Text, Touchable } from '@factorialco/deprecated-design-system'

import DayPicker from 'modules/core/components/DayPicker'
import RadioInput from 'modules/core/components/Inputs/FilterSelect/SelectOption/RadioInput'
import { dateToString, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

interface Props {
  isSelected: boolean
  title: string
  description: string
  onClick: () => void
  date?: moment.Moment
  setDate?: (date: moment.Moment) => void
}

const Option = ({ isSelected, title, description, onClick, date, setDate }: Props) => {
  const hasDropdown = isSelected && date
  const inputId = 'daypicker-input'

  return (
    <Box
      borderRadius={hasDropdown ? {} : { all: 'abs008' }}
      border={
        !hasDropdown && {
          all: isSelected
            ? { width: 's2', style: 'solid', color: 'viridian1000' }
            : { width: 's1', style: 'solid', color: 'grey400' },
        }
      }
      background="grey000White"
    >
      <Box
        padding="s16"
        gap="s8"
        borderRadius={hasDropdown ? { topLeft: 'abs008', topRight: 'abs008' } : {}}
        border={
          hasDropdown && {
            all: isSelected
              ? { width: 's2', style: 'solid', color: 'viridian1000' }
              : { width: 's1', style: 'solid', color: 'grey400' },
          }
        }
        onClick={onClick}
      >
        <Box flexDirection="row" justifyContent="spaceBetween" alignItems="center">
          <Text size="300" weight="medium" color="grey800">
            {title}
          </Text>
          <Box flexDirection="row" alignItems="center">
            <Touchable onClick={onClick}>
              <RadioInput selected={isSelected} />
            </Touchable>
          </Box>
        </Box>
        <Text size="300" weight="normal" color="grey800">
          {description}
        </Text>
      </Box>
      {hasDropdown && (
        <Box
          flexDirection="row"
          alignItems="center"
          justifyContent="spaceBetween"
          padding="s16"
          background="grey100"
          gap="s16"
          border={{
            left: { width: 's1', style: 'solid', color: 'grey400' },
            right: { width: 's1', style: 'solid', color: 'grey400' },
            bottom: { width: 's1', style: 'solid', color: 'grey400' },
          }}
          borderRadius={{ bottomRight: 'abs008', bottomLeft: 'abs008' }}
        >
          <label htmlFor={inputId}>
            <Text size="300" weight="medium" color="grey800">
              {i18n.t('time_tracking.settings.versions.effective_date')}
            </Text>
          </label>
          <Box style={{ flexBasis: '10rem' }}>
            <DayPicker
              inputId={inputId}
              value={dateToString(date, 'ui')}
              onChange={(newDate: string) => setDate && setDate(stringToDate(newDate, 'ui'))}
            />
          </Box>
        </Box>
      )}
    </Box>
  )
}

export default Option
